// Generated by ts-to-zod
import { z } from 'zod';

export const invokeResponseSchema = z.unknown();

export const invokePayloadSchema = z.union([
  z.record(z.unknown()),
  z.undefined(),
]);
